import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import NavBar from "../components/navbar"



/* const activestyles = {
color: `#b54147`,
textdecoration: `none`
}
 */


const Header = ({ siteTitle }) => (
  
    <div style={{ marginBottom: `1.5rem` }}>
      <NavBar></NavBar>
      
       
      
      
      <section class="hero is-danger">
  <div class="hero-body">
    <div class="container">
      
<Link class="button is-danger is-large is-invert is-family-secondary" to={"/"}>PublicArtSG </Link>      
      <h2 class="subtitle">
      
      </h2>
    </div>
  </div>
 
</section>
    </div>

)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
